// extracted by mini-css-extract-plugin
export default {"mapper":"TemplatePropertyMapper_mapper__0ZrfH","header":"TemplatePropertyMapper_header__ZoXNo"};